import { createAction, Action } from 'redux-actions';

export const SET_REINITIALIZING = 'CLIENT.SET_REINITIALIZING';

export type SetReinitializingAction = Action<boolean>;

export const setReinitializing = createAction<boolean>(SET_REINITIALIZING);
